import React from "react";
import { FaFacebookF, FaInstagram, FaLinkedinIn } from "react-icons/fa";
import { MapPin, Mail, Phone } from "lucide-react";
import { Link } from "react-router-dom";

const Footer = () => {
  return (
    <footer className="bg-black text-white py-10 px-6 sm:px-10 md:px-16 lg:px-24">
      <div className="max-w-screen-xl mx-auto flex flex-wrap justify-between gap-10 text-center lg:text-left">
        {/* Logo & About Section */}
        <div className="w-full md:w-1/2 lg:w-1/4">
          <div className="flex items-center justify-center lg:justify-start gap-3 mb-4">
            <Link to="/" className="hover:text-green-500 transition-all">
              <img src="/logo.svg" alt="Logo" className="h-10" />
            </Link>
          </div>
          <p className="text-gray-300 text-sm sm:text-base leading-relaxed">
            Growing excellence with premium cultivars. Our passion for nature
            meets innovation in every bloom.
          </p>
        </div>

        {/* Quick Links */}
        <div className="w-full sm:w-1/2 lg:w-1/4">
          <h3 className="text-lg sm:text-xl font-semibold text-green-400 mb-4">
            Quick Links
          </h3>
          <ul className="space-y-2 text-sm sm:text-base">
            {["Home", "Cultivars", "About Us", "Contact"].map((link) => (
              <li key={link}>
                <a
                  href={`/${link.toLowerCase().replace(" ", "")}`}
                  className="text-gray-400 hover:text-green-400 transition duration-300 hover:translate-x-1 block"
                >
                  {link}
                </a>
              </li>
            ))}
          </ul>
        </div>

        {/* Contact Info */}
        <div className="w-full sm:w-1/2 lg:w-1/4">
          <h3 className="text-lg sm:text-xl font-semibold text-green-400 mb-4">
            Contact Us
          </h3>
          <div className="text-gray-300 space-y-2">
            <p className="flex items-center justify-center lg:justify-start">
              <MapPin className="text-green-400 w-5 h-5 sm:w-6 sm:h-6 mr-2" />
              <span className="hover:text-green-400 transition duration-300 cursor-pointer">
                Maple Ridge, British Columbia, Canada
              </span>
            </p>
            <p className="flex items-center justify-center lg:justify-start">
              <Mail className="text-green-400 w-5 h-5 sm:w-6 sm:h-6 mr-2" />
              <a
                href="mailto:info@beyondbloom.ca"
                className="hover:text-green-400 transition duration-300 underline"
              >
                info@beyondbloom.ca
              </a>
            </p>
            <p className="flex items-center justify-center lg:justify-start">
              <Phone className="text-green-400 w-5 h-5 sm:w-6 sm:h-6 mr-2" />
              <a
                href="tel:+11234567890"
                className="hover:text-green-400 transition duration-300 underline"
              >
                +1 (236) 427-2834
              </a>
            </p>
          </div>
        </div>

        {/* Social Media Icons */}
        <div className="w-full sm:w-1/2 lg:w-1/4">
          <h3 className="text-lg sm:text-xl font-semibold text-green-400 mb-4">
            Follow Us
          </h3>
          <div className="flex justify-center lg:justify-start gap-4 text-xl">
            {[
              { icon: <FaFacebookF />, link: "https://facebook.com" },
              { icon: <FaInstagram />, link: "https://instagram.com" },
              { icon: <FaLinkedinIn />, link: "https://linkedin.com" },
            ].map(({ icon, link }, index) => (
              <a
                key={index}
                href={link}
                target="_blank"
                rel="noopener noreferrer"
                className="text-green-500 hover:text-green-400 transition duration-300 transform hover:scale-110 p-2 rounded-full border border-green-500"
              >
                {icon}
              </a>
            ))}
          </div>
        </div>
      </div>

      {/* Stylish Divider */}
      <div className="border-t border-gray-700 mt-10 pt-6 text-center">
        <p className="text-sm sm:text-base text-gray-500">
          © 2025 Beyond Bloom Canna Corp™. All Rights Reserved.
        </p>
        <p className="text-sm sm:text-base text-gray-500 mt-2">
          Developed by{" "}
          <a
            href="https://odidor.co/"
            target="_blank"
            rel="noopener noreferrer"
            className="text-green-500 hover:text-green-400 transition duration-300"
          >
            Odidor
          </a>
        </p>
      </div>
    </footer>
  );
};

export default Footer;
